import React, { useEffect, useState } from "react";
import GoogleMapsContext from "./GoogleMapsContext";
import Script from "next/script";

function GoogleMapsProvider({ children }: any) {
  const [maps, setMaps] = useState(false);
  useEffect(() => {
    if (typeof window !== "undefined") {
      if (Boolean((window as any)?.google?.maps)) {
        setMaps(true);
      }
    }
  }, [setMaps]);
  const onLoad = () => {
    setMaps(true);
  };
  return (
    <React.Fragment>
      <Script
        id="google-maps"
        strategy="afterInteractive"
        type="text/javascript"
        src={`https://maps.googleapis.com/maps/api/js?key=AIzaSyCm2c6tgVNmZA5p_4royX9HfrJOeFe4yCk&libraries=places`}
        onLoad={onLoad}
      />
      <GoogleMapsContext.Provider value={{ maps }}>
        {children}
      </GoogleMapsContext.Provider>
    </React.Fragment>
  );
}

export default GoogleMapsProvider;
